<template>
  <!--切换账户 列表 组件-->
  <div v-if="ywtAccountChoose ? accountList.length > 0 :totalAccountList.length > 0" class="change-account">
<!--    这里搜索好像用不起，直接写死，以防万一-->
    <div class="search-profile" v-if="showSearch && false">
      <el-input v-model="searchText" size="mini" width="100%">
        <i slot="prefix" class="el-icon-search"></i>
      </el-input>
    </div>
    <div
      class="wrap"
      :style="{ paddingTop: showSearch ? lineHeight + 10 + 'px' : '0' }"
    >
      <!--加入企业的账号列表-->
      <ul>
        <template>
          <li
            v-for="(user, index) in accountList"
            v-show="user"
            :title="user.corpName || user.name"
            :style="{ height: lineHeight + 'px' }"
            :class="tabActiveFn(user)"
            @click="changeAccount(user)"
            :key="index"
          >
            <div class="d-box">
              <template v-if="personOrEnt(user)">
                <span class="sn">我自己</span>
              </template>
              <span class="sn joined" v-else>加入的</span>
              <img
                style="width: 20px; height: 20px; margin-right: 0"
                v-if="user.userStemFrom === -16 && !isInDingTalk"
                src="/images/icon/dingIcon.png"
                alt=""
              />
              <template  v-if="user.systemType === 'ywt'">
                <img style="max-height: 28px" src="../../static/images/ywt_logo.png" alt="">
                <span>（{{(user.corpName || user.name).substring(0, 5)}}）</span>
              </template>
              <span v-else>{{ user.corpName || user.name }}</span>
            </div>
            <span
              v-show="tabActiveFn(user) === 'active' && showImg"
              class="current-user"
            >
              <img
                src="../../static/images/console/seleted.png"
                alt=""
                class="el-icon-check"
              />
            </span>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import {setCurrentUser} from "@/assets/js/http-serve/corp/common";
import { fileOperShow } from "@/assets/js/http-serve/http-methods";
import { isInDingTalk } from "../../assets/js/utils/ding-env";
import {ApiMethods} from "../../assets/js/http-serve/http-methods";

export default {
  name: "index",
  props: {
    lineHeight: {
      type: Number
    },
    users: {
      type: Array
    },
    /** 只是切换不做其他操作 */
    justSwitching:{
      type: Boolean,
      default: false
    },
  //  是否隐藏自己
    hideSelf: {
      type: Boolean,
      default: false,
    },
  // 1794 是否是需要选择业务通账号的切换 .默认不是(有些页面身份切换不需要ywt菜单，只在控制台有ywt身份的切换)
    ywtAccountChoose: {
      type: Boolean,
      default: false,
    },
    //是否显示图片
    showImg: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      isInDingTalk,
      searchText: "",
      accountList: [],
      fileOperShow: fileOperShow
    };
  },
  computed: {
    authUser() {
      return this.$store.getters.authUser;
    },
    currentAuthUser() {
      return this.$store.getters.currentAuthUser || {};
    },
    showSearch() {
      return this.totalAccountList.length > 5 && !this.justSwitching;
    },
    totalAccountList() {
      let arr = [];
      arr = arr.concat(this.$store.getters.allAuthUser.bindCorpUsers);
      if (arr.length > 0) {
        this.$emit("showExpandIcon");
      }
      return arr;
    }
  },
  mounted() {
    this.initAccountList();
  },
  methods: {
    tabActiveFn(user) {
      if (this.$route.path === '/ywtSystem') { //在iframe ywt页面（说明）
        if (user.userType) { //是企业用户（企业加入企业这种）当他没有匹配到userId和corpUserId时说明一定用的是manCorpUser, current 用manCorpUser时一定是登录号, 没用manCorpUser时就去对比userId和corpUserId,
          return ((user.userId && this.currentAuthUser.userId === user.userId || user.corpUserId && this.currentAuthUser.corpUserId === user.corpUserId || this.authUser.userType && this.authUser.userId === user.userId) && user.systemType === 'ywt') ? 'active' : '';
        } else { // 成员用户 ，用corpUserId判断选中
          return  (this.currentAuthUser.corpUserId === user.corpUserId && user.systemType === 'ywt') ? 'active' : ''
        }
      } else { //不在iframe ywt页面，在君子签控制台
        if (user.userType) { //是企业用户（企业加入企业这种）
          return ((user.userId && this.currentAuthUser.userId === user.userId || user.corpUserId && this.currentAuthUser.corpUserId === user.corpUserId || this.authUser.userType && this.authUser.userId === user.userId) && user.systemType !== 'ywt') ? 'active' : ''
        } else { // 成员用户 ，用corpUserId判断选中
          return  (this.currentAuthUser.corpUserId === user.corpUserId && user.systemType !== 'ywt') ? 'active' : ''
        }
      }
    },
    initAccountList() {
      this.accountList = [];
      //添加bingCorpUser
      if (this.totalAccountList) {
        this.totalAccountList.forEach(user => {
          this.accountList.push(user);
        });
      }
      //钉钉里过滤钉钉的
      if (isInDingTalk) {
        this.accountList = this.accountList.filter(item => {
          item.userStemFrom == -16;
        });
      }
      //添加自己
      this.accountList.push(this.$store.getters.authUser)
      //条件隐藏自己
      if (this.hideSelf) {
        this.accountList = this.accountList.filter(item => {
          return item.corpUserId;
        })
      }
      //加入的企业有ywt账户选择的时候 1794
      if (this.ywtAccountChoose && !isInDingTalk) {
        this.accountList = this.accountList.flatMap((item) => {
          return (item.corpIsMerchant === 1 || item.merchantFlag === 1) && item.ywtIsBind ? [item, {systemName: '业务定制系统', systemType: 'ywt', ...item}] : item;
        })
      }
      //  当自己开通了业务通账户的时候
      this.ywtAccountListFn();
    },
    //ywt
    ywtAccountListFn() {
      ApiMethods.ProfileController.ywtActivateStatus().then(res => {
        if (res.data === 1) {
          this.accountList.unshift({systemName: '业务定制系统', systemType: 'ywt', ...this.authUser})
        }
      })
    },
    // 切换用户时，也要清空搜索文字
    changeAccount(user) {
      if(this.justSwitching) return this.$emit('justCall',user)
      //如果是切换业务通; 2种情况： 是否需要切换身份后再转业务通 1794
      if (user.systemType === 'ywt') {
        if (user.userId && this.currentAuthUser.userId === user.userId ||
          user.corpUserId && this.currentAuthUser.corpUserId === user.corpUserId ||
          this.authUser.userType && this.authUser.userId === user.userId) { // 不需要切换身份
          if (this.$route.path !== '/ywtSystem') {
            this.$router.push({
              path: '/ywtSystem',
              query: {
                ...this.$route.query,
                ywtLayoutStyle: 2,
                work: 2
              },
            });
          } else {
          //  这里是重复点击
          }
        } else { //否则，在类型===ywt的时候，就是需要切换身份的情况
          setCurrentUser(user).finally(() => {
            if (this.$route.path !== '/ywtSystem') {
              this.$router.push({
                path: '/ywtSystem',
                query: {
                  ...this.$route.query,
                  ywtLayoutStyle: 2,
                  work: 2,
                },
              });
            } else {
              location.reload();
            }
          })
        }
      } else { //不是业务通用原逻辑，只在前边加一个同账户路由切换（这种是新情况）1794
        //同账户路由切换，下面旧逻辑是没有同账户的
        if (user.userId && this.currentAuthUser.userId === user.userId ||
          user.corpUserId && this.currentAuthUser.corpUserId === user.corpUserId ||
          this.authUser.userType && this.authUser.userId === user.userId) {
          if (this.$route.path === '/ywtSystem') { //这是在ywt页面点击同账户的情况，把路由跳回去
            this.$router.push({
              path: (user.userType || user.corpUserId) ? "/console/member" :"/tpl/personSet",
              query: { signStatus: 2 }
            });
          } else {
          // 这里是重复点击，不进行操作
          }
        } else if (!user.corpUserId) { //旧逻辑
          setCurrentUser(user).finally(() => {
            this.$router.push({
              path: "/tpl/personSet",
              query: { signStatus: 2 }
            });
          })
        } else if (this.personOrEnt(user) && user.userStemFrom !== -16) {
          this.searchText = "";
          setCurrentUser(this.$store.getters.allAuthUser.manCorpUser).finally(
            () => {
              if (
                this.$store.getters.currentAuthUser &&
                this.$store.getters.currentAuthUser.corpUserId &&
                (this.$route.path === "/signInfo/preservation" ||
                  this.$route.path === "/signInfo/baoguanhan")
              ) {
                this.$router.push({
                  path: "/corp/signInfo/signList",
                  query: { signStatus: 2 }
                });
              }
            }
          );
        } else if (!(user.perms && user.perms.length > 0)) {
          return this.$message.error("暂无权限，请联系管理员开通。");
        } else {
          this.searchText = "";
          setCurrentUser(user).finally(() => {
            if (this.$route.path === '/ywtSystem') { //这里也需要设置，以防不能回跳页面
              this.$router.push({
                path: (user.userType || user.corpUserId) ? "/console/member" :"/tpl/personSet",
                query: { signStatus: 2 }
              });
            } else if (
              this.$store.getters.currentAuthUser &&
              this.$store.getters.currentAuthUser.corpUserId &&
              (this.$route.path === "/signInfo/preservation" ||
                this.$route.path === "/signInfo/baoguanhan")
            ) {
              this.$router.push({
                path: "/corp/signInfo/signList",
                query: { signStatus: 2 }
              });
            }
          });
        }
      }
    },
    // 搜索账户列表
    doFilter(val) {
      try {
        if (val) {
          this.accountList = [];
          // 循环搜索加入企业的账户
          this.totalAccountList.forEach(user => {
            if (user.corpName) {
              if (user.corpName.indexOf(val) != -1) {
                this.accountList.push(user);
              }
            } else {
              if (user.name.indexOf(val) != -1) {
                this.accountList.push(user);
              }
            }
          });
        } else {
          // 初始化账户列表
          this.initAccountList();
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 是否是企业或者个人账户
    personOrEnt(user) {
      let name = user.corpName || user.name;
      return (
        this.$store.getters.allAuthUser &&
        this.$store.getters.allAuthUser.accountInfoVO.name === name
      );
    },
    getTitle(user) {
      let isPersonOrEntBool = this.personOrEnt(user);
      let name = user.corpName || user.name;
      let accountName = this.$store.getters.allAuthUser
        ? this.$store.getters.allAuthUser.accountInfoVO.name
        : "";
      return isPersonOrEntBool ? name : name + "-" + accountName;
    }
  },
  watch: {
    // 检测全部用户是否更新，调用initAccountList函数初始化用户列表
    "$store.getters.allAuthUser": {
      handler(val) {
        this.initAccountList();
      },
      deep: true
    },
    searchText: {
      handler(val) {
        this.doFilter(val);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.change-account {
  position: relative;
  .search-profile {
    position: absolute;
    padding-right: 20px;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    .el-input {
      width: 100%;
    }
  }
  .wrap {
    position: relative;
    max-height: 50vh;
    overflow-y: scroll;
  }
  li {
    box-sizing: border-box;
    padding: 11px 20px 11px 10px;
    position: relative;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    font-size: 14px;
    overflow-y: hidden;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /*transition: all 0.5s;*/
    img {
      height: 30px;
      margin-right: 10px;
    }
    &:hover {
      background: #f9f6f6;
      .joined {
        width: 46px;
      }
    }
    .current-user {
      width: 35px;
      height: 30px;
      position: absolute;
      right: 0 !important;
      top: 0;

      img {
        vertical-align: top;
        width: 35px;
        height: 30px;
        margin: 0 !important;
      }
    }
  }
  .photo {
    max-width: 30px;
    max-height: 30px;
    border-radius: 50%;
    border: solid 1px #c5c5c5;
  }
  .isPersonOrEnt {
    display: inline-block;
    font-size: 12px;
    color: #9d8d8d;
    background: #e4e2e2;
    border-radius: 30px;
    padding: 2px 8px;
    line-height: initial;
  }
  .d-box {
    text-align: left;
    line-height: initial;
    flex: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    /*max-width: 170px;*/
    /*max-width: 90%;*/
    width: 100%;
  }
}
.active {
  color: #ec1c1c;
  background: #eeeeee;
  .sn {
    background: #fef3f3;
  }
  .joined {
    /*display: block;*/
    width: 46px;
  }
}
.sn {
  text-align: center;
  font-size: 12px;
  background: #eeeeee;
  border-radius: 19px;
  box-sizing: border-box;
  transition: all ease-in 0.15s;
  display: inline-block;
  width: 46px;
  height: 20px;
  line-height: 20px;
  margin-right: 5px;
  vertical-align: text-bottom;
  overflow: hidden;
}
.joined {
  width: 0;
}
</style>



// WEBPACK FOOTER //
// components/change-account/index.vue